import { EncryptStorage } from 'encrypt-storage';

// config
const STORAGE_SECRET_KEY = import.meta.env.VITE_STORAGE_SECRET_KEY || 'secret-key';

const options = {
  prefix: '@ps',
  storageType: 'localStorage',
  stateManagementUse: false,
};

export const encryptStorage = new EncryptStorage(STORAGE_SECRET_KEY, options);
